<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import Pagination from "@/components/standard/Induction/components/InductionPagination";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import EliminacionResiduosAPI from "@/services/standards/eliminacionResiduos/eliminacionResiduosAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import EliminacionResiduosPagination from "../../../components/standard/eliminacionResiduos/EliminacionResiduosPagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title:
      "3.1.9 Eliminación adecuada de residuos sólidos, líquidos o gaseosos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    Pagination,
    PageHeader,
    Table,
    CheckModal,
    EliminacionResiduosPagination,
  },
  data() {
    return {
      title:
        "3.1.9 Eliminación adecuada de residuos sólidos, líquidos o gaseosos",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Eliminación adecuada de residuos sólidos, líquidos o gaseosos",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: "",

      file: null,

      eliminacion: {
        type_document: null,
        file: null,
        description: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      lastId: 1,
      deleteCount: 0,
      company: null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      form_submitting: false,
      loading1: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
    };
  },
  validations: {
    file: {
      required,
    },
    eliminacion: {
      type_document: {
        required,
      },
    },
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(31)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.9/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.9/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.eliminacion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading1 = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitted = false;
        this.loading1 = false;
        return;
      } else {
        let response = await this.uploadDocument();
        if (!response) {
          this.loading1 = false;
          this.submitted = false;
          Swal.fire({
            title: "Error",
            text: "Error al registrar intente de nuevo",
            type: "error",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }
        if (response) {
          EliminacionResiduosAPI.save(this.eliminacion)
            .then((response) => {
              const itemChange = {
                companies_id: this.companyID,
                item_id: 31,
                status: 'Pendiente',
              };
              newScoresAPI.calculateScores(itemChange)
                .then((response) => {
                  this.sendNotification(61, 31, true);
                  this.loading1 = false;
                  this.submitted = false;
                  setTimeout(() => {
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Se ha registrado con éxito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  this.loading1 = false;
                  this.submitted = false;
                  setTimeout(() => {
                    Swal.fire({
                      title: "Error",
                      text: "¡No se ha podido registrar!",
                      icon: "error",
                      type: "error",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }, 1000);
                  console.log(error);
                });
            })
            .catch((error) => {
              this.loading1 = false;
              this.submitted = false;
              Swal.fire({
                title: "Error",
                text: "Error al guardar los datos",
                type: "error",
                icon: "error",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              console.log(error);
            });
        }
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          const uuid = response && response.uuid ? response.uuid : null;
          if (uuid) {
            CompanySSOAPI.getCompany(uuid)
              .then((r) => {
                this.company = r && r.nit ? r.nit : null;
                this.loading1 = false;
              })
              .catch((error) => {
                console.log(error);
                this.loading1 = false;
              });
          } else {
            this.loading1 = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 31)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/sst-prod/estandares/3.1.9/INSTRUCTIVO_MANEJO_INTEGRAL_RESIDUOS_3.1.9.doc";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    deleteEliminacion(id) {
      EliminacionResiduosAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 31,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getEliminacion() {
      EliminacionResiduosAPI.get(this.companyID)
        .then((response) => {
          const datos = (response && response.data && response.data.data) ? response.data.data : [];
          this.list = datos;
          this.deleteCount = Array.isArray(datos) ? datos.length : 0;
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false;
        });
    },

    getLastId() {
      EliminacionResiduosAPI.getAll(this.companyID, '', '')
        .then((response) => {
          const datos = (response && response.data && response.data.data) ? response.data.data : [];
          if (datos.length && datos[0] && datos[0].id) {
            this.lastId = datos[0].id + 1;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 31,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getEliminacion();
    this.getLastId();
    // Garantizar que loading1 se desactive después de 5 segundos como fallback
    setTimeout(() => {
      this.loading1 = false;
    }, 5000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12 pl-3">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe garantizar que realiza un manejo adecuado
                      de los residuos que se producen, así como los residuos
                      peligrosos, de forma que no se ponga en riesgo a los
                      trabajadores, para esto debe definir como realizar la
                      separación en la fuente, almacenamiento y disposición
                      final garantizando la disposición final adecuada,
                      especialmente de los residuos peligrosos o especiales.
                    </p>
                    <p class="text-justify">
                      En la base de conocimiento podrá tener acceso a un
                      instructivo donde se especifica el manejo y la empresa
                      deberá adaptarlo a sus condiciones.
                    </p>
                    <p class="text-justify">
                      Se deben subir evidencias de la implementación de este
                      ítem, especialmente los certificados de la disposición
                      final de los residuos peligrosos.
                    </p>
                  </CheckModal>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="row pt-3 px-3">
                <div class="col-12 d-flex justify-content-end">
                  <a href="#" @click="print">Instructivo manejo de residuos</a>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12 pt-2 px-2">
                  <b-form-group class="col-md-6 px-2" label="Tipo documento a subir" label-for="theme">
                    <b-form-select :disabled="!allowAccess() || !getRole('Crear')" id="theme"
                      v-model="eliminacion.type_document" :class="{
                        'is-invalid':
                          $v.eliminacion.type_document.$error && submitted,
                      }">
                      <b-form-select-option value="Instructivo de la Empresa">
                        Instructivo de la Empresa
                      </b-form-select-option>
                      <b-form-select-option value="Evidencia implementación">
                        Evidencia implementación
                      </b-form-select-option>
                    </b-form-select>
                    <div v-if="submitted && $v.eliminacion.type_document.$error">
                      <small v-if="!$v.eliminacion.type_document.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Evidencia" label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="file" ref="file" name="file"
                      browse-text="Buscar" :placeholder="`Selecciona un archivo...`" drop-placeholder="Suelta acá..."
                      v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :class="{
                        'is-invalid': $v.file.$error && submitted,
                      }">
                    </b-form-file>
                    <div v-if="submitted && $v.file.$error">
                      <small v-if="!$v.file.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>
                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="eliminacion.description" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
              <hr class="px-2" />
              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3 px-2">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">
                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>

                    <div class="table-responsive">
                      <table
                        class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
                        <thead class="table-active">
                          <tr>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Fecha
                            </th>

                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Tipo de documento
                            </th>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-8">
                              Observaciones
                            </th>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Evidencia
                            </th>
                            <th scope="col"
                              class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-2">
                              Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="item in list" :key="item.id">
                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ dateConvert(item.created_at) }}
                            </td>

                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ item.type_document }}
                            </td>

                            <td class="px-6 text-sm text-gray-500 mx-2">
                              {{ item.description }}
                            </td>

                            <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                              <div v-if="item.file === null">
                                <h6>No hay archivo disponible</h6>
                              </div>
                              <div v-else>
                                <button :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="gotoDigitalOcean(`${item.file}`)">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                              </div>
                            </td>
                            <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary" :disabled="!allowAccess() || !getRole('Editar')
                                  ">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                    " v-b-modal="`modal${item.id}`">
                                    Editar
                                  </b-dropdown-item>
                                  <b-modal :id="`modal${item.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                    <div class="text-justify">
                                      <h4 class="mt-2 text-primary text-center">
                                        Advertencia
                                      </h4>
                                      <p class="mt-3">
                                        Al modificar esta información se quitará
                                        el puntaje correspondiente a este ítem y
                                        será necesario realizar nuevamente la
                                        validación por parte del usuario
                                        responsable de Emisión.
                                      </p>
                                      <button type="button" @click="
                                        goPage(
                                          `/forms/estandares/eliminacion-residuos-editar/${item.id}`
                                        )
                                        " class="btn btn-primary my-2 mx-2" data-dismiss="`modal${item.id}`"
                                        :disabled="!allowAccess()">
                                        Continuar
                                      </button>
                                      <button type="button" @click="
                                        $bvModal.hide(`modal${item.id}`)
                                        " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                        Cancelar
                                      </button>
                                    </div>
                                  </b-modal>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                    " :to="{
                                      path: `/forms/estandares/eliminacion-residuos-ver/${item.id}`,
                                    }">
                                    Ver
                                  </b-dropdown-item>
                                  <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                    " v-on:click="deleteEliminacion(item.id)">Eliminar</b-dropdown-item>
                                </b-dropdown>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <EliminacionResiduosPagination ref="paginator" @loading="(load) => (loading = load)"
                        :search="search" @fetch="(items) => (list = items)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
